<div class="sftpControlWrapper">
    @if (sftpIds.length) {
        <ul class="sftpSelectionContainer">
            @for (sftpId of sftpIds; track sftpId) {
                <li class="sftpSelection">
                    <span>{{ sftpIdNameMap.get(sftpId) }}</span>
                    <div class="actionButtons">
                        <button class="button transparent onlyIcon small" (click)="openSFTPSettingsModal(sftpId)">
                            <i class="far fa-pencil"></i>
                        </button>
                        <button class="button transparent onlyIcon danger small" (click)="deleteSftp(sftpId)">
                            <i class="far fa-trash"></i>
                        </button>
                    </div>
                </li>
            }
        </ul>
    }
    <button class="button default icon" (click)="openSFTPSettingsModal()">
        <i class="far fa-plus"></i>
        <span>{{ 'generalKeywords.add' | translate }}</span>
    </button>
</div>
